import { canvasLabelMeasurer } from '@ardoq/graph-labeling';
import { LABEL_FONT_SIZE } from '../relationshipsView/consts';
import { ARDOQ_DEFAULT_FONT_FAMILY } from '@ardoq/typography';

const measureSvgText = canvasLabelMeasurer(
  `normal ${LABEL_FONT_SIZE}px/normal ${ARDOQ_DEFAULT_FONT_FAMILY}, sans-serif`
);
export { measureSvgText };
